<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('accountInfo.titleText') }}
                Col
                    RadioGroup(:value="$route.path" @on-change="gotoRoute" :style="{'width': '100%'}" horizontal)
                        Radio(label="/account-info/user" border)
                            Span {{ $t('accountInfo.userInfoText') }}
                        Radio(label="/account-info/security" border)
                            Span {{ $t('accountInfo.securityText') }}
                        Radio(label="/account-info/payment" border v-if="$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow && ($store.getters.isAdmin || $can('read', 'billingPermission','')) && $store.state.queryGroupName!='all'")
                            Span {{ $t('accountInfo.paymentText') }}
        Card(style="max-height: 75vh;overflow-y: scroll")
            router-view
</template>
<script>
import UserInfoPage from "./AccountInfo/userInfo";
import SecurityPage from "./AccountInfo/security";
import PaymentPage from "./AccountInfo/payment";
export default {
    components: { UserInfoPage, SecurityPage, PaymentPage },
    data() {
        return {
            pageName: "UserInfoPage",
        };
    },
    methods: {
        choosePage(pageName) {
            this.pageName = pageName;
        },
        gotoRoute(path) {
            let routeTo = { path };
            let { groupName } = this.$route.query;
            if (groupName) routeTo.query = { groupName };
            this.$router.push(routeTo);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/view/general/AccountInfo.vue